import { httpClient } from 'api/HttpClient';
import { IPayment } from 'app/pages/AddPaymentPage/IPayment';
import { dateUtils } from 'utils/date-utils';
//import { IResponseType } from 'types/ResponseType';
const url = '/api/odata/v4/Payment';
export interface IPaymentPayload extends IPayment {
  ShouldCloseInvoice?: boolean;
}
export const PaymentApi = {
  AddPayment: (payment: IPaymentPayload) => {
    const data = {
      InvoiceId: payment.InvoiceId,
      MethodId: payment.Method?.Id,
      Amount: payment.Amount,
      Date:
        /**
         * Date must be in the ISO 18601 format regardless of the input junk. Otherwise the API will return 500 NullReferenceException
         * Examples of valid formats:
         * "Date":"2025-10-12T07:29:50.5887783Z"
         * Example of invalid format:
         * "Date":"2025-10-12T10:34:33.8129978"
         */
        payment.Date === undefined
          ? undefined
          : dateUtils.formatISO(dateUtils.dateOrStringToDate(payment.Date)),
      Remarks: payment.Remarks,
      Reference: payment.Reference,
      BudgetId: payment.Budget?.Id,
      ServiceGroupId: payment.ServiceGroup?.Id,
      ShouldCloseInvoice: payment.ShouldCloseInvoice,
    };
    return httpClient.post<any>(url, data);
  },
  UpdatePayment: (paymentId: number, payment: IPaymentPayload) => {
    const data = {
      InvoiceId: payment.InvoiceId,
      MethodId: payment.Method?.Id,
      Amount: payment.Amount,
      Date: payment.Date,
      Remarks: payment.Remarks,
      Reference: payment.Reference,
      BudgetId: payment.Budget?.Id,
      ServiceGroupId: payment.ServiceGroup?.Id,
      ShouldCloseInvoice: payment.ShouldCloseInvoice,
    };
    return httpClient.put(url + '(' + paymentId + ')', data);
  },
};
